import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'frontend-verify-profile',
  templateUrl: './verify-profile.component.html',
  styleUrls: ['./verify-profile.component.scss'],
})
export class VerifyProfileComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
